import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-release-notes-dialog',
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss']
})
export class ReleaseNotesDialogComponent extends AbstractDialogContent implements OnInit {

  public className = 'ReleaseNotesDialogComponent';

  public version: string
  public isHidden: boolean = true

  constructor(
    public activeModal: NgbActiveModal,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.version = localStorage.getItem('appVersion')
    this.isHidden = localStorage.getItem('hideReleaseNotes') === 'true'
    
    setTimeout(() => {document.getElementById('release-notes-close').focus()}, 100)
  }

  toggleHidden() {
    this.isHidden = !this.isHidden
    localStorage.setItem('hideReleaseNotes', this.isHidden.toString())
  }
}
